import type { Messages } from './en';

export const MESSAGES_IT: Messages = {
  secure_tagadapay: 'Pagamento Sicuro da Tagada',
  checkout_title: 'Pagamento Sicuro',
  checkout_subtitle: 'Completa il tuo acquisto in modo sicuro',
  express_payment: 'Pagamento Express',
  express_payment_apple_pay: 'Paga con Apple Pay',
  express_payment_subtitle: 'Salta il modulo di checkout',
  informations_title: 'Informazioni',
  informations_subtitle: 'Inserisci le tue informazioni personali',
  shipping_address_title: 'Indirizzo di Spedizione',
  shipping_address_subtitle: 'Inserisci il tuo indirizzo di spedizione',
  shipping_method_title: 'Metodo di Spedizione',
  shipping_method_subtitle: 'Seleziona il tuo metodo di spedizione qui sotto',
  shipping_method_warning_title: 'Informazione',
  shipping_method_warning_text: 'Nessun metodo di spedizione trovato nel tuo paese',
  billing_address_check: "L'indirizzo di fatturazione è diverso dall'indirizzo di spedizione",
  billing_method_title: 'Metodo di Fatturazione',
  billing_method_subtitle: 'Inserisci il tuo indirizzo di fatturazione',
  payment_title: 'Pagamento',
  payment_subtitle:
    'Seleziona il tuo metodo di pagamento qui sotto. Tutte le transazioni sono sicure e crittografate',
  payment_credit_card: 'Carta di credito o debito',
  payment_credit_card_subtitle: 'Pagamento sicuro con carta di credito o debito',
  payment_paypal_subtitle: 'Pagamento sicuro e veloce con PayPal',
  payment_bridge_subtitle: 'Pagamento sicuro e veloce con Bridge',
  payment_klarna_subtitle: 'Pagamento sicuro e veloce con Klarna',
  payment_generic_subtitle: 'Pagamento sicuro e veloce',
  default_payment_method_short: 'Predefinito',
  order_summary_discount_code: 'Codice sconto',
  order_summary_discount_discovered_callout: 'Abbiamo trovato codici sconto per te',
  order_summary_discount_discovered_callout_action: 'Aggiungili tutti',
  order_summary_title: 'Il tuo ordine',
  order_summary_subtotal: 'Subtotale',
  order_summary_shipping: 'Spedizione',
  order_summary_discount: 'Sconto',
  order_summary_tax: 'Tasse stimate',
  order_summary_total: 'Totale',
  order_summary_total_savings: 'Risparmi',
  button_pay: 'Paga ora',
  button_pay_with_gateway: 'Paga con {gateway}',
  loading: 'Caricamento...',
  error_missing_checkout_session_id: 'ID sessione di pagamento mancante',
  error_checkout_session_not_found: 'Sessione di pagamento non trovata',
  error_order_already_completed: 'Ordine già completato',
  error_checkout_session_items_empty: 'Il tuo carrello è vuoto',
  order_not_found: 'Ordine non trovato',
  thank_you_title: 'Grazie per il tuo ordine!',
  thank_you_subtitle: 'Il tuo ordine è stato elaborato con successo.',
  thank_you_email_sent: 'Abbiamo inviato una email di conferma al tuo indirizzo email registrato:',
  thank_you_order_details: "Dettagli dell'Ordine",
  thank_you_reference: 'Riferimento',
  thank_you_date: 'Data',
  thank_you_total: 'Totale',
  thank_you_button_continue: 'Continua lo Shopping',
  term_and_privacy_clicking_text: 'Cliccando qui, accetto',
  term_and_condition_link_text: 'Termini e Condizioni',
  privacy_policy_link_text: 'Informativa sulla Privacy',
  refund_policy_link_text: 'Politica di Rimborso',
  shipping_policy_link_text: 'Politica di Spedizione',
  billed_as_text: 'La tua carta di credito verrà addebitata come {domain}.',
  you_must_accept_policies: 'Devi accettare le nostre',
  and: 'e',
  comma: ',',
  payment_error_title: 'Errore',
  checkout_preview_title: 'Modalità Anteprima - Questa è una bozza della pagina di checkout',
  order_summary_discount_code_apply_button: 'Applica',
  optional: 'Opzionale',
  field_phone: 'Telefono',
  field_phone_placeholder: 'Inserisci il tuo numero di telefono',
  field_phone_required_text: 'Il numero di telefono è obbligatorio',
  field_company: 'Azienda',
  field_company_placeholder: 'Inserisci il nome della tua azienda',
  checkbox_billing_address: "L'indirizzo di fatturazione è diverso dall'indirizzo di spedizione",
  billing_address_title: 'Indirizzo di Fatturazione',
  billing_address_subtitle: 'Inserisci il tuo indirizzo di fatturazione',
  field_first_name: 'Nome',
  field_first_name_placeholder: 'Inserisci il tuo nome',
  field_first_name_error_message: 'Questo campo è obbligatorio',
  field_last_name: 'Cognome',
  field_last_name_placeholder: 'Inserisci il tuo cognome',
  field_last_name_error_message: 'Questo campo è obbligatorio',
  field_address: 'Indirizzo',
  field_address_placeholder: '123 Via Principale, Città, Paese',
  field_address_error_message: 'Questo campo è obbligatorio',
  field_additional_address: 'Indirizzo Aggiuntivo',
  field_additional_address_placeholder: 'Appartamento, suite, unità, ecc.',
  field_additional_address_error_message: 'Questo campo è obbligatorio',
  field_city: 'Città',
  field_city_placeholder: 'Inserisci la tua città',
  field_city_error_message: 'Questo campo è obbligatorio',
  field_country: 'Paese',
  field_country_error_message: 'Questo campo è obbligatorio',
  field_state: 'Stato/Regione',
  field_state_placeholder: 'Inserisci il tuo stato/regione',
  field_state_error_message: 'Questo campo è obbligatorio',
  field_postal_code: 'Codice Postale',
  field_postal_code_placeholder: 'Inserisci il tuo codice postale',
  field_postal_code_error_message: 'Questo campo è obbligatorio',
  field_email: 'Email',
  field_email_placeholder: 'Inserisci la tua email',
  field_email_error_message: 'Questo campo è obbligatorio',
  credit_card_method: 'Carta di credito o debito',
  card_error_message: 'Informazioni carta non valide',
  card_number: 'Numero carta',
  card_number_placeholder: 'Inserisci il numero della carta',
  card_number_error_message: 'Questo campo è obbligatorio',
  expiry_date: 'Data di scadenza',
  expiry_date_placeholder: 'MM/AA',
  expiry_date_error_message: 'Questo campo è obbligatorio',
  expiry_date_error_message_expired: 'La data di scadenza è passata',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'Il CVC deve essere di 3 o 4 cifre',
  payment_methods_loading_error: 'Impossibile caricare i metodi di pagamento',
  recommanded: 'Consigliato',
  free: 'Gratuito',
  customer_update_error: 'Impossibile aggiornare le informazioni',
  shipping_method_empty_country: 'Seleziona un paese per vedere i metodi di spedizione disponibili',
  shipping_method_update_error: 'Impossibile aggiornare le informazioni di spedizione',
  items: '{count} articoli',
  back: 'Indietro',
  continue_to_shipping: 'Continua alla spedizione',
  continue_to_payment: 'Continua al pagamento',
  contact_title: 'Contatto',
  contact_title_subtitle: 'Inserisci le tue informazioni di contatto',
  pay_now: 'Paga ora',
  secure_payment_message: 'Tutte le transazioni sono sicure e crittografate',
  interval_day: 'giorno',
  interval_week: 'settimana',
  interval_month: 'mese',
  interval_year: 'anno',
  interval_day_plural: 'giorni',
  interval_week_plural: 'settimane',
  interval_month_plural: 'mesi',
  interval_year_plural: 'anni',
  every_interval: 'Ogni {count} {interval}',
  billing_every_interval: 'Fatturazione ogni {count} {interval}',
  delivery_every_interval: 'Consegna ogni {count} {interval}',
  free_trial_period: '{duration} {type} di prova gratuito',
  first_payment_free: 'Primo pagamento gratuito',
  subscription_trial_notice:
    'Il tuo abbonamento include un periodo di prova gratuito. Non ti verrà addebitato nulla fino alla fine del periodo di prova.',
  recurring_total_with_interval: 'Totale ricorrente (ogni {count} {interval})',
  trial_ends_on: 'Il periodo di prova termina il {date}',
  billing_timing: 'Fatturazione: {timing}',
  billing_cycle_anchor: 'Ancoraggio ciclo di fatturazione',
  field_marketing_label: 'Accetto di ricevere email di marketing',
  terms_acceptance_text: 'Cliccando qui, accetto',
  cart_title: 'Carrello',
  payment_failed_message: 'Pagamento fallito',
  email: {
    abandoned_checkout: {
      preview: 'Completa il tuo acquisto',
      default_body:
        'Abbiamo notato che hai lasciato alcuni articoli nel carrello. Vorresti completare il tuo acquisto?',
      cart_title: 'Il tuo Carrello',
      quantity: 'Quantità',
      recurring: 'Ricorrente ogni {interval}',
      trial_period: '({duration} {type} di prova)',
      subtotal: 'Subtotale',
      discounts: 'Sconti',
      total: 'Totale',
      cta_button: 'Completa il tuo acquisto',
      footer_text: 'Se hai domande, rispondi semplicemente a questa email - siamo sempre felici di aiutare.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'Non autorizzato',
      unsupported_content_type: 'Tipo di contenuto non supportato',
      single_file_required: 'È richiesto un singolo file',
      file_too_big: 'Il file è troppo grande',
      non_image_file: 'Impossibile gestire file non immagine',
    },
  },
  promotion_code_invalid: 'Questo codice sconto non è valido',
  applying: 'Applicazione...',
  processing_payment: 'Elaborazione del pagamento...',
  select_country: 'Seleziona un paese',
  select_state: 'Seleziona un stato',
  order_details: "Dettagli dell'ordine",
  order_number: "Numero dell'ordine",
  order_date: "Data dell'ordine",
  email_confirmation: 'Conferma via email',
  confirmation_sent_to: 'Email di conferma inviata a',
  shipping_address: 'Indirizzo di spedizione',
  billing_address: 'Indirizzo di fatturazione',
  payment_successful: 'Pagamento riuscito',
  recurring_total: 'Totale ricorrente',
  payment_is_blacklisted: 'Il pagamento è bloccato',
  checkout_has_errors_title: 'Validazione',
  checkout_has_errors: 'Le informazioni qui sotto sono invalide o mancanti',
  checkout_email_error: 'indirizzo email',
  checkout_shipping_address_error: 'indirizzo di spedizione',
  checkout_billing_address_error: 'indirizzo di fatturazione',
  checkout_shipping_rate_error: 'tariffa di spedizione',
  checkout_pickup_address_error: 'indirizzo di ritiro',
  checkout_payment_info_error: 'informazioni di pagamento',
  checkout_phone_error: 'numero di telefono',
  checkout_terms_error: 'non hai accettato le condizioni generali',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'Si è verificato un errore imprevisto. Riprova.',
  },
  checkout_completed_title: 'Pagamento Completato',
  checkout_already_completed: 'Questo ordine è già stato pagato',
  payment_completed: 'Pagamento Completato',
  apply_vip_offers: 'Paga ora come VIP',
  confirm_vip_payment: 'Paga',
  cancel_vip_offers: 'Annulla offerte VIP',
  vip_total_difference: 'Differenza: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'Risparmio VIP',
  vip_savings_available: 'Risparmio VIP Disponibile',
  vip_savings_confirmed: 'Risparmio VIP Applicato',
  vip_savings_message: 'Seleziona il pagamento VIP per sbloccare questi risparmi!',
  vip_savings_applied_message: 'Stai risparmiando {amount} con i benefici VIP!',
  vip_offer_savings_confirmed: 'Offerta VIP Applicata',
  vip_offer_savings_available: 'Offerta VIP Disponibile',
  vip_offer_savings_message: "Applica l'offerta VIP per risparmiare sul tuo ordine",
  vip_offer_savings_applied_message: "Hai risparmiato {amount} con l'offerta VIP",
  apply_vip_offer: 'Paga come VIP',
  cancel_vip_offer: 'Annulla Offerta VIP',
  you_save: 'Risparmi {amount}',
  you_save_on_order: 'Risparmi {amount} sul tuo ordine',
  you_save_available: "Risparmia {amount} sul tuo ordine con l'offerta VIP esclusiva",
  free_trial_then_price: 'Prova gratuita di {duration} {type}, poi {price}/{interval}',
  free_trial_period_short: '{duration} {type} gratuito',
  click_to_apply: 'Clicca per applicare',
  please_select_shipping_country: 'Seleziona un paese per vedere i metodi di spedizione disponibili',
  invalid_phone_number: 'Numero di telefono non valido',
  click_errors_to_navigate: 'Clicca sugli errori per navigare alle sezioni',
  pickup_point: 'Punto di Ritiro',
  monday: 'Lunedì',
  tuesday: 'Martedì',
  wednesday: 'Mercoledì',
  thursday: 'Giovedì',
  friday: 'Venerdì',
  saturday: 'Sabato',
  sunday: 'Domenica',
  promotion_code_usage_limit_reached: 'Questo codice promozionale ha raggiunto il suo limite di utilizzo',
  promotion_code_first_time_only: 'Questo codice promozionale è valido solo per i nuovi clienti',
  promotion_code_invalid_email: 'Questo codice promozionale non è valido per il tuo indirizzo email',
  promotion_code_cannot_apply: 'Questo codice promozionale non può essere applicato',
  promotion_code_already_applied: 'Questa promozione è già stata applicata',
  promotion_code_expired: 'Questo codice promozionale è scaduto',
  promotion_code_cannot_remove_auto: 'Non è possibile rimuovere le promozioni applicate automaticamente',
  promotion_code_remove_failed: 'Rimozione del codice promozionale non riuscita',
  remove: 'Rimuovi',
  pickup_select_point: 'Seleziona punto di ritiro',
  pickup_select_point_description: 'Scegli un punto di ritiro vicino a te',
  pickup_click_to_select: 'Clicca per selezionare',
  pickup_change_point: 'Cambia punto di ritiro',
  pickup_change: 'Cambia',
  pickup_opening_hours: 'Orari di apertura',
  pickup_closed: 'Chiuso',
  pickup_point_error: 'Si è verificato un errore durante la selezione del punto di ritiro',
  pickup_view_list: 'Vista elenco',
  pickup_view_map: 'Vista mappa',
  pickup_open_map: 'Apri mappa',
  pickup_open_map_description: 'Clicca per aprire la mappa interattiva',
  pickup_no_points_found: 'Nessun punto di ritiro trovato in questa zona',
  cancel: 'Annulla',
  order_confirmed: 'Ordine Confermato',
  view_order_details: 'Visualizza Dettagli Ordine',
  back_to_portal: 'Torna al Portale',
  customer_details: 'Dettagli Cliente',
  customer_email: 'Email',
  customer_id_label: 'ID Cliente',
  customer_first_name: 'Nome',
  customer_last_name: 'Cognome',
  customer_locale: 'Lingua',
  marketing_consent: 'Preferenze di Marketing',
  marketing_accepted: 'Iscritto al marketing',
  marketing_declined: 'Non iscritto al marketing',
  customer_created_at: 'Cliente Da',
  order_status_label: 'Stato Ordine',
  order_status_paid: 'Pagato',
  order_status_pending: 'In sospeso',
  order_status_cancelled: 'Annullato',
  post_purchase: {
    title: 'Abbiamo trovato queste offerte apposta per te',
    view_deal: 'Visualizza offerta',
    get_deal_now: 'Ottieni subito',
    bundle_content: '{count, plural, =0 {nessun articolo} =1 {# articolo} other {# articoli}}',
    adding_to_cart: 'Elaborazione in corso...',
    vip_only: 'Solo VIP',
    products: '{count, plural, =0 {Nessun prodotto} =1 {# prodotto} other {# prodotti}}',
    skip: 'salta',
    skip_addition: 'vai al riepilogo',
    exclusive_offer: 'Offerta esclusiva una tantum',
    offer_expires_in: "L'offerta scade tra",
    minutes: 'min',
    save: 'Risparmia',
    secure_checkout: 'Checkout sicuro',
    safe_payment: 'Pagamento sicuro',
    limited_time_offer: 'Offerta a tempo limitato',
    previous: 'Precedente',
    no_thanks: 'No grazie',
    offer_count: 'Offerta {current} di {total}',
    special_offer_title: 'Offerta speciale per te',
  },
  billing_plan: 'Piano di Fatturazione',
  customer: 'Cliente',
  current_period: 'Periodo Corrente',
  trial_period: 'Periodo di Prova',
  cancellation_notice: 'Avviso di Cancellazione',
  subscription_cancellation_end_period: 'Questo abbonamento verrà cancellato alla fine del periodo corrente.',
  created: 'Creato',
  product_id: 'ID Prodotto',
  resuming: 'Ripristino in corso...',
  resume_subscription: 'Riprendi Abbonamento',
  canceling: 'Annullamento in corso...',
  cancel_subscription: 'Annulla Abbonamento',
  my_subscriptions: 'I Miei Abbonamenti',
  subscriptions: 'abbonamenti',
  no_active_subscriptions: 'Non hai abbonamenti attivi.',
  active: 'Attivo',
  trial: 'Prova',
  loading_subscriptions: 'Caricamento dei tuoi abbonamenti...',
  qty: 'Qtà',
  id: 'ID',
  by_canceling: 'Annullando:',
  lose_club_advantages: 'Perderai tutti i vantaggi di essere membro del club',
  lose_accumulated_credits: 'Perderai tutti i crediti accumulati finora',
  lose_promotion_code:
    'Perderai il tuo codice promozionale personale con sconti esclusivi su tutto il negozio',
  confirm_proceed: 'Sei sicuro di voler procedere?',
  cancel_club_membership:
    'Questo cancellerà la tua iscrizione al club alla fine del ciclo di fatturazione corrente.',
  cancel_subscription_notice:
    'Questo cancellerà il tuo abbonamento alla fine del ciclo di fatturazione corrente.',
  keep_subscription: 'Mantieni Abbonamento',
  yes_lose_benefits: 'Sì, voglio perdere tutti i benefici di essere membro del Subclub',
  yes_cancel: 'Sì, Annulla',
  cancel_subscription_title: 'Annulla Abbonamento',
  membership: 'Adesione',
  related_orders: 'Ordini Correlati',
  related_orders_description: 'Ordini effettuati tramite offerte post-acquisto',
  order_status: 'Stato',
  order_total: 'Totale',
  order_items: 'Articoli',
  order_type: 'Tipo',
  view_order: 'Visualizza Ordine',
  order_item_count: '{count, plural, =1 {# articolo} other {# articoli}}',
  related_order_from: 'Da offerta {offerType}',
  no_related_orders: 'Nessun ordine correlato',
  total_with_related_orders: 'Totale con ordini correlati',
  discount_applied: 'Sconto applicato',
  paid: 'Pagato',
  pending: 'In sospeso',
  processing: 'In elaborazione',
  cancelled: 'Annullato',
  refunded: 'Rimborsato',
  vip_post_purchase: {
    title: 'Hai ancora tempo!',
    subtitle: 'Iscriviti al nostro club e vinci alla grande!',
    action_cancel: 'No, grazie',
    action_subscribe: 'Iscriviti',
    savings: 'Risparmi {amount}',
    offer_title: 'Offerta Esclusiva da Non Perdere',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'ID Punto di Ritiro',
        name: 'Nome Punto di Ritiro',
        street: 'Indirizzo Punto di Ritiro',
        type: 'Tipo Punto di Ritiro',
        city: 'Città Punto di Ritiro',
        postal_code: 'CAP Punto di Ritiro',
        country: 'Paese Punto di Ritiro',
        carrier: 'Corriere Punto di Ritiro',
        code: 'Codice Punto di Ritiro',
        latitude: 'Latitudine Punto di Ritiro',
        longitude: 'Longitudine Punto di Ritiro',
      },
    },
  },
};
